import Icon from "@3gaam/shared/components/general/icon";
import React from "react";
import { useNavigate } from "react-router-dom";

const SecondaryHeader = React.memo(({ title }: { title: string }) => {
  const navigate = useNavigate();

  return (
    <header className="header-height border-bottom text-gray1 d-flex flex-row align-items-center bg-white text-center">
      <span
        onClick={() => navigate(-1)}
        className="open-drawer d-flex font-32 cur-pointer mr-3"
      >
        <Icon name="far-fa-chevron-right" />
      </span>
      <span className="font-18 font-weight-medium mr-2">{title}</span>
    </header>
  );
});

export default SecondaryHeader;
